import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Card, LoadingBlock, EmptyState } from "@/components/common";
import { formatDate } from "@/lib/format";
import { Star } from "lucide-react";

export default function Recensioni() {
  const { data, isLoading } = useQuery({ queryKey: ["prof-reviews"], queryFn: async () => (await api.get("/professional/reviews")).data });
  const reviews = (data?.reviews || []).filter((r) => r.status === "published");
  const avg = reviews.length ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1) : 0;

  return (
    <DashboardLayout title="Recensioni">
      {isLoading ? <LoadingBlock /> : reviews.length === 0 ? (
        <EmptyState title="Nessuna recensione" subtitle="Le recensioni dei pazienti appariranno qui dopo le prestazioni completate." />
      ) : (
        <>
          <Card className="mb-6 flex items-center gap-4">
            <span className="text-4xl font-extrabold text-[#087A73]">{avg}</span>
            <div>
              <div className="flex">{[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`h-5 w-5 ${n <= Math.round(avg) ? "text-[#D99A00] fill-[#D99A00]" : "text-[#D2E3DB]"}`} />)}</div>
              <p className="text-sm text-[#5C6B68] mt-1">{reviews.length} recensioni</p>
            </div>
          </Card>
          <div className="space-y-3">
            {reviews.map((r) => (
              <Card key={r.id}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex">{[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`h-4 w-4 ${n <= r.rating ? "text-[#D99A00] fill-[#D99A00]" : "text-[#D2E3DB]"}`} />)}</div>
                  <span className="text-xs text-[#5C6B68]">{formatDate(r.created_at)}</span>
                </div>
                {r.comment && <p className="text-sm text-[#5C6B68]">{r.comment}</p>}
              </Card>
            ))}
          </div>
        </>
      )}
    </DashboardLayout>
  );
}
